<template>
	<div class="filter-modifiers">
		<Button
			v-if="hasFilters"
			size="small"
			text
			:label="matchLabel"
			@click="handleMatchChange" />
		<Button
			v-if="hasFilters"
			label="Clear filters"
			size="small"
			text
			@click="handleClearClick" />
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Button from 'primevue/button'
import type { Filters } from '@/helpers/filters/Filters'

const props = defineProps<{ filters: Filters<any> }>()

const emit = defineEmits<{
	(e: 'updated'): void
}>()

const hasFilters = computed(() => props.filters.list.size > 0)
const matchLabel = computed(() => `Match ${props.filters.mode === 'all' ? 'all' : 'any'} filters`)

function handleMatchChange() {
	props.filters.toggleMode()
	emit('updated')
}

function handleClearClick() {
	props.filters.list.clear()
	emit('updated')
}
</script>

<style scoped lang="scss">
.filter-modifiers {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
	justify-content: flex-end;
}
</style>
